const ui = (state = {
  form_visible: false,
}, action) => {
  switch (action.type) {
    case 'TOGGLE_FORM':
      return Object.assign({}, state, {
        form_visible: !state.form_visible,
      });
    default:
      return state
  }
}

export default ui;




// WEBPACK FOOTER //
// ./src/reducers/ui.js